
import { Component, Vue } from 'vue-property-decorator';
import { BlockStore, UserStore } from '@/store/modules';

import SvgIcon from '@/components/SvgIcon.vue';
import ImportBlockForm from '@/components/Forms/Blocks/ImportBlockForm.vue';
import QvInput from '@/components/FormComponents/QvInput.vue';
import { ValidationObserver } from 'vee-validate';
import { QTablePagination } from '@/store/models/meta';

import { colors, date } from 'quasar';
import { Invitation, UserTypes } from '@/store/models/user';
import { roleChecker } from '@/utils/jwt';
const { getPaletteColor } = colors;

@Component({
  components: {
    SvgIcon,
    ImportBlockForm,
    ValidationObserver,
    QvInput
  }
})
export default class InvitationList extends Vue {
  invitation: Invitation | null = null;
  loading = false;
  cancelInvitationDialog = false;
  filter = '';

  deleteUserDialog = false;
  isCurrentPwd = true;
  password = '';

  tableColumn = [
    {
      name: 'id',
      label: 'Id',
      field: (row: Invitation) => row.id,
      sortable: true,
      align: 'left',
      style: 'width: 10px',
      headerStyle: 'width: 10px;'
    },
    {
      name: 'user',
      label: 'Invited By',
      field: (row: Invitation) => row.userEmail,
      sortable: true,
      align: 'left'
    },
    {
      name: 'invited_to',
      label: 'Invited To',
      field: (row: Invitation) => row.invitedTo,
      sortable: true,
      align: 'left'
    },
    {
      name: 'user_type',
      label: 'Invited As',
      field: (row: Invitation) => row.userType,
      sortable: true,
      align: 'left',
      classes: 'text-capitalize'
    },
    {
      name: 'created_date',
      label: 'Invited On',
      field: (row: Invitation) => {
        const dt = new Date(row.createdDate);
        const formattedDate = date.formatDate(dt, 'MMM DD, YYYY hh:mm A');
        return formattedDate;
      },
      sortable: true,
      align: 'left'
    },
    {
      name: 'status',
      label: 'Status',
      field: (row: Invitation) => {
        if (row.isExpired) {
          return 'Expired';
        }
        return row.status;
      },
      sortable: true,
      align: 'left',
      classes: 'text-capitalize'
    },
    {
      name: 'actions',
      label: 'Actions',
      align: 'left',
      style: 'width: 260px;'
    }
  ];

  get invitations() {
    return UserStore.PaginatedInvitation;
  }

  get invitationPagination() {
    return UserStore.InvitationTablePagination;
  }

  set invitationPagination(data: QTablePagination) {
    UserStore.setInvitationTablePagination(data);
  }

  get importBlockDialogVisible() {
    return BlockStore.ImportBlockDialogVisible;
  }
  set importBlockDialogVisible(value: boolean) {
    BlockStore.setImportBlockDialogVisible(value);
  }

  //eslint-disable-next-line
  async onRequest(props: any) {
    const { page, rowsPerPage, sortBy, descending } = props.pagination;
    const filter = props.filter;
    this.loading = true;

    const ordering = `${descending ? '-' : ''}${sortBy}`;

    const queryParams = {
      page: page,
      search: filter,
      ordering: ordering,
      pageSize: rowsPerPage
    };
    await UserStore.getInvitations(queryParams);
    this.loading = false;

    this.invitationPagination = {
      page: this.invitations.currentPage,
      rowsPerPage: this.invitations.pageSize,
      rowsNumber: this.invitations.totalObjects,
      sortBy: sortBy,
      descending: descending
    };
  }

  getPaletteColor(colorName: string) {
    return getPaletteColor(colorName);
  }

  // async onDelete(blockId: number) {
  //   this.deleteDialog = false;
  //   if (blockId != 0) {
  //     BlockStore.deleteBlock(blockId);

  //     BlockStore.setAddEditBlock({} as Block);
  //   }
  // }

  showCancelInvitationDialog(invitation: Invitation) {
    this.invitation = invitation;
    this.cancelInvitationDialog = true;
  }

  async cancelInvitation() {
    if (this.invitation) {
      await UserStore.cancelInvitationById(this.invitation.id);
      this.loadInvitations();
    }
    this.cancelInvitationDialog = false;
  }

  loadInvitations() {
    this.onRequest({
      pagination: this.invitationPagination,
      filter: this.filter
    });
  }

  showDeleteUserDialog(invitation: Invitation) {
    if (invitation.usedBy && invitation.usedBy.id) {
      this.invitation = invitation;
      this.deleteUserDialog = true;
    }
  }

  async deleteUser() {
    if (
      this.invitation &&
      this.invitation.usedBy &&
      this.invitation.usedBy.id
    ) {
      await UserStore.deleteInvitedUser({
        id: this.invitation.id,
        userId: this.invitation.usedBy.id,
        password: this.password
      });
      this.$q.notify({
        message: `The user ${this.invitation.usedBy.fullName} and all their data was deleted`,
        type: 'positive'
      });
    }
    this.deleteUserDialog = false;
  }
  cancelDeleteUser() {
    requestAnimationFrame(() => {
      this.password = '';
      this.deleteUserDialog = false;
    });
  }

  async created() {
    if (!roleChecker([UserTypes.ADMIN])) {
      // Remove Invited by column if not admin
      this.tableColumn.splice(1, 1);
    }
    this.loading = true;
    this.loadInvitations();
    this.loading = false;
  }
}
